import { useCancelBlotterOrder } from './hooks/useCancelBlotterOrder';
import type { BlotterProcessedRow } from './types';
import type { ICellRendererParams } from '@ag-grid-community/core';
import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCallback } from 'react';
import { Tooltip } from 'src/components/ui';
import { container } from 'src/StaticContainer';

interface IMessageCellRendererParams extends ICellRendererParams {
    data: BlotterProcessedRow;
}

const log = container.get('Logger').getSubLogger({ name: 'order-blotter-actions' }, { component: 'trading' });

export const ActionsCellRenderer = (props: IMessageCellRendererParams) => {
    const canCancel = props.value.includes('cancel');
    const id = props.data.id;
    const cancelOrder = useCancelBlotterOrder();

    const onClick = useCallback(() => {
        cancelOrder(id);
    }, [id, cancelOrder]);

    if (TRACE) {
        log.trace({ message: 'Rendering ActionsCellRenderer', canCancel, id });
    }

    if (!canCancel) {
        return null;
    }

    return (
        <Tooltip content="Cancel order">
            <FontAwesomeIcon icon={faTimes} onClick={onClick} className="hover:text-destructive" />
        </Tooltip>
    );
};
